import { transformDependentListValue } from './list.dependent.transformers'
import { transformDrilldownListValue } from './list.drilldown.transformers'

/**
 *
 * @param valueObj
 * @param rowObj
 * @param templateField
 * @param templateFields
 * @returns {*}
 */
export function transformList(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  const listGovernance = getListGovernance(templateField)
  const list = listGovernance.lists || {}
  const listType = list.type

  if (listType === 'dependent') {
    return transformDependentListValue(
      valueObj,
      rowObj,
      templateField,
      templateFields,
      context,
      dataContainer,
      readOnlyTransform,
    )
  }
  if (listType === 'drill-down') {
    return transformDrilldownListValue(
      valueObj,
      rowObj,
      templateField,
      templateFields,
      context,
      dataContainer,
      readOnlyTransform,
    )
  }
  // Sort multiselect values
  const { delimiter, multi } = getListGovernance(templateField)
  if (multi && valueObj.cell_value)
    return valueObj.cell_value
      .split(delimiter)
      .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
      .join(delimiter)
  return valueObj.cell_value
}

function getListGovernance(templateField) {
  const governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field
  return governanceOwner.list_governance
}
